import React, { Component } from 'react'
import SideNavbar from '../components/navbars/SideNavbar'
import NavbarOne from '../components/navbars/NavbarOne'
import Preloader from '../components/preloader/Preloader'
import OrganizationProfileSection from '../components/settings/organization/OrganizationProfileSection'
import { PageCardShimmer } from '../components/preloader/PageCardShimmer'
import Footer from '../components/footer/Footer';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import { canView } from "../../utils/modulePermissions";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
  } from "react-device-detect";

// The organisation query lives on this page, not in OrganizationProfileSection, so
// the is_view skip has to sit here — otherwise the profile would be fetched and
// cached even though the section renders Access Denied.
// module_key ONLY, never module_name ("Settings" is the shared sidebar group).
const ORGANIZATION_PROFILE_MODULE = ["organization_profile"];

class OrganizationProfile extends Component {
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
         if (toggled === "wrapper") {
             this.setState({toggled:"wrapper sidebar-enable"});
             Cookies.set("toggle", "wrapper sidebar-enable");
         } else {
             this.setState({toggled:"wrapper"});
             Cookies.set("toggle", "wrapper");
         }
     };
    render() {
        if (Cookies.get("token") == undefined) this.props.history.push("/login");
        // When the query is skipped (is_view === 0) react-apollo passes no data prop
        // at all, so default it — the section renders Access Denied in that case.
        const getOrganisationProfile = this.props.getOrganisationProfile || {};
        const loading3 = getOrganisationProfile.loading;
        const error3 = getOrganisationProfile.error;
        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                    
                </div>
                <div className="main-wrapper">

                <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
                    <SideNavbar onClick={() => this.menuToggler()} />
                </div>
                <Preloader />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        {loading3 ? (
                            <PageCardShimmer filters={3} />
                        ) : (
                            <OrganizationProfileSection
                                getOrganisationProfile={getOrganisationProfile.getOrganisationProfile} />
                        )}
                    </div>
                    <Footer />
                </div>
            </div>
        )
    }
}
export default compose(
    graphql(gql` 
    query($institution_id: Int!) {
        getOrganisationProfile(institution_id: $institution_id){
            id
            organisation_name
            chairman
            contact_no
            complete_address
            region_id
            logo
            hod
            hod_mobile
            principal
            principal_mobile
            vice_principal
            vice_principal_mobile
            timestamp
        }
    }
    `,
        {
            options: props => ({
                variables: {
                    institution_id: parseInt(Cookies.get("institutionid"))
                },

            }),
            // is_view === 0 → don't fetch the profile at all.
            skip: () => !canView(ORGANIZATION_PROFILE_MODULE),
            name: "getOrganisationProfile"
        }
    ))(OrganizationProfile);
